import React from 'react';

import WrappedBase from './WrappedBase';
import VariantImage from '../containers/VariantImage';

export default class VariantImageWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <VariantImage {...this.props} />
      </WrappedBase>
    );
  }
}
